import React from 'react';
import { NoTasksSVG } from '@bb/elements-web';

import { DuplicateListingsForAgentType } from 'api/DuplicateListingController';
import { Divider, Icon } from 'components';
import { featureEnabled } from 'utils';
import { EmptyContainer, EmptySection } from '../../components';
import DuplicatesItem from './DuplicatesItem';

type DuplicatesSectionProps = {
  items: DuplicateListingsForAgentType['data'];
  fetchDuplicates: () => Promise<void>;
};

const DuplicatesSection: React.FC<DuplicatesSectionProps> = ({
  items,
  fetchDuplicates,
}) => {
  if (!items.length) {
    if (featureEnabled('showingsMadeEasyFeature')) {
      return (
        <EmptySection
          dataCy="duplicates-empty"
          Image={<NoTasksSVG width={133} height={120} />}
          mainText="No tasks yet"
          secondaryText="View incoming tasks that require your attention here."
        />
      );
    }

    return (
      <EmptyContainer data-cy="duplicates-empty">
        <Icon
          type="antdShrinkOutlined"
          width={32}
          color="gray6"
          offset={[0, 3]}
        />
        <span>No duplicates yet</span>
      </EmptyContainer>
    );
  }

  return (
    <>
      {items.map((item, index) => {
        if (index === items.length - 1) {
          return (
            <DuplicatesItem
              duplicate={item}
              index={index}
              fetchDuplicates={fetchDuplicates}
            />
          );
        }

        return (
          <React.Fragment key={index}>
            <DuplicatesItem
              duplicate={item}
              index={index}
              fetchDuplicates={fetchDuplicates}
            />
            <Divider style={{ margin: 0 }} />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default DuplicatesSection;
